import {
    Phone,
    MessageCircle,
    Eye,
    Landmark,
    Mail
} from "lucide-react";

import Avatar from "../shared/Avatar";
import Card from "../shared/Card";
import Button from "../shared/Button";
import StatusBadge from "../shared/StatusBadge";

import { formatCurrency } from "../../utils/formatCurrency";
import { formatDate } from "../../utils/formatDate";

export default function LeadCard({

    lead,

    onView,

    onCall,

    onWhatsapp

}){

    return(

       <Card className="crm-lead-card">

    <div className="crm-lead-header">

        <div className="crm-lead-user">

            <Avatar
                name={`${lead.first_name} ${lead.last_name}`}
                size={52}
            />

            <div className="crm-lead-info">

                <h3>

                    {lead.first_name} {lead.last_name}

                </h3>

            </div>

        </div>

        <StatusBadge

            status={lead.status}

        />

    </div>

    <div className="crm-lead-loan">

        <div className="crm-loan-type">

            <Landmark size={16}/>

            <span>

                {lead.loan_type}

            </span>

        </div>

        <div className="crm-loan-amount">

            {formatCurrency(

                lead.loan_amount

            )}

        </div>

<p style={{display:"flex",justifyContent:"left",gap:10,fontSize:"13px"}}>
                <Phone size={15}/>

                        {lead.mobile}

                    </p>
<p style={{display:"flex",justifyContent:"left",gap:10,fontSize:"12px"}}>
   
                        <Mail size={15}/>

                        {lead.email || "-"}

                    </p>
    </div>

    <div className="crm-info-grid">

        <div className="crm-info-item">

            <label>

                Mother

            </label>

            <span>

                {lead.mother_name || "-"}

            </span>

        </div>

        <div className="crm-info-item">

            <label>

                Created

            </label>

            <span>

                {formatDate(lead.created_at)}

            </span>

        </div>

    </div>

    <div className="crm-card-actions">

        <Button

            variant="ghost"

            icon={<Phone size={16}/>}

            onClick={onCall}

        />

        <Button

            variant="ghost"

            icon={<MessageCircle size={16}/>}

            onClick={onWhatsapp}

        />

        <Button

            icon={<Eye size={16}/>}

            onClick={onView}

        >

            View

        </Button>

    </div>

</Card>

    );

}